import React from 'react';

const Manuscript: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M84.25 9.211v19.904c0 1.217 1.013 2.212 2.25 2.212h20.25"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M106.75 31.327L84.25 9.21H23.5c-1.238 0-2.25.996-2.25 2.212v106.154c0 1.216 1.012 2.211 2.25 2.211h81c1.238 0 2.25-.995 2.25-2.211v-86.25z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M66.25 71.135h-9v8.846h9v-8.846zm0 26.538h-9v8.846h9v-8.846zm27-26.538h-9v8.846h9v-8.846zm-9 17.692h9m-18 17.692h9v-8.846h9v8.846m-18-8.846v-8.846h-18m18-8.847v-8.845m-40.5-17.693h58.5m-58.5 8.847h58.5m-58.5 8.846h13.5m18-26.539h27m-58.5 35.385h13.5m-13.5 8.846h13.5m-13.5 8.846h13.5m-13.5 8.846h13.5m13.5-79.615h-9v-8.846h-9v8.846h-9v8.846h9v8.846h9V35.75h9v-8.846z"
    ></path>
  </svg>
);

export default Manuscript;
